<template>
  <div id="nav-btns">
    <font-awesome-icon v-if="back" icon="arrow-circle-left" class="fa-2x icon-row__icon"
            @click="$router.back()" />
    <font-awesome-icon v-if="home" icon="home" class="fa-2x icon-row__icon"
            @click="$router.push(home)" />
    <font-awesome-icon v-if="close" icon="times-circle" class="fa-2x icon-row__icon"
            @click="$router.push(close)" />
    <font-awesome-icon v-if="check" icon="check-circle" class="fa-2x icon-row__icon"
            @click="$router.push(check)" />
    <font-awesome-icon v-if="details" icon="file-alt" class="fa-2x icon-row__icon"
            @click="$router.push(details)" />
  </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    FontAwesomeIcon,
  },
  props: {
    back: String,
    home: String,
    check: String,
    close: String,
    details: String,
  },
};
</script>
